import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as ReportServices from "../../../../services/ReportService";
import { useTranslation } from "react-i18next";
import ReportForm from "./reportForm.view";
import PATHS from "../../../../constants/paths";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import * as userService from "../../../../services/UserServices";
import { ROLE_EVALUATOR, ROLE_EVALUATOR_MANAGER } from "../../../../constants";

// import {
//   BreadCrumb,
//   ShowAlertDialog,
// } from "@de-prado-dev/react-component-library";

const ReportFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [initValues, setInitValues] = useState({});
  const [skills, setSkills] = useState(null);
  const [users, setUsers] = useState([]);

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      department: data.department || "",
      year: data.year || new Date().getFullYear(),
      numEvaluations: data.numEvaluations || 0,
      goals1: data.goals.goals1 || 0,
      goals2: data.goals.goals2 || 0,
      goals3: data.goals.goals3 || 0,
      goals4: data.goals.goals4 || 0,
      goals5: data.goals.goals5 || 0,
      competencies1: data.competencies.competencies1 || 0,
      competencies2: data.competencies.competencies2 || 0,
      competencies3: data.competencies.competencies3 || 0,
      competencies4: data.competencies.competencies4 || 0,
      competencies5: data.competencies.competencies5 || 0,
      responsables: data.responsables || [],
    };
    setInitValues(dataFinal);
  }, []);
  //  const competenciesLabels = {};
  // if (skills && Array.isArray(skills)) {
  //   skills.forEach((skill, index) => {
  //     const currentLang = i18n.language; // 'es' o 'pt'
  //     const translationKey = `translation.${currentLang}`;
  //     const label =
  //       skill[translationKey] || skill.translation?.es || skill.name;
  //     competenciesLabels[`Competencia ${index + 1}`] = label;
  //   });
  // }
  const loadData = useCallback(async () => {
    const competenciesLabels = {};
    const usersBack = await userService.listFilterUser({
      roles: ROLE_EVALUATOR_MANAGER,
    });
    setUsers(usersBack);
    const skills = await ReportServices.getProfessionalSkills();
    if (skills && Array.isArray(skills)) {
      skills.forEach((skill, index) => {
        const currentLang = i18n.language;
        const translationKey = `translation.${currentLang}`;
        const label =
          skill[translationKey] || skill.translation?.es || skill.name;
        competenciesLabels[`Competencia ${index + 1}`] = label;
      });
      setSkills(competenciesLabels);
    }
    if (uuid) {
      const result = await ReportServices.getReport(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await ReportServices.updateReport(values, uuid);
        } else {
          result = await ReportServices.addReport(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.report.messages.update.title");
            text = t("forms.report.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.report.messages.create.title");
            text = t("forms.report.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.report.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.CONFIG);
        };
        showDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.CONFIG);
  };

  return (
    <ReportForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onBack={handleOnback}
      skills={skills}
      users={users}
    />
  );
};

ReportFormContainer.propTypes = {
  t: PropTypes.any,
};

export default ReportFormContainer;
